import { ReactNode } from 'react'

export default function Container({ children }: { children: ReactNode }) {
  return (
    <main className={`nhsuk-width-container`} id='maincontent' role='main'>
      <div className='nhsuk-main-wrapper pt-0'>{children}</div>
    </main>
  )
}
